import React from "react";
import { renderToString } from "react-dom/server";
import { getMetricDataFromArray, getMetricsDataFromArray } from "../../../Metrics/utils";
import ChartTooltip from "./ChartTooltip";
import ChartLegend from "./ChartLegend";
import ChartSubtitle from "./ChartSubtitle";
import { getExportFileName } from "../../utils";
import { getEventDetails, eventTracker } from "../../../../generic/Utils/eventTracker";
import { safeMutate } from "../../../../../utils/GeneralUtils";

const getChartConfig = function (props = {}) {

  const { metrics, seriesMetricsUids, subTitleMetricUid, exportFileName, metricColorMap } = props;
  const seriesMetrics = getMetricsDataFromArray(metrics, seriesMetricsUids);
  const subTitleMetic = getMetricDataFromArray(metrics, subTitleMetricUid);

  const getAdditionalEventDetails = function (initialEventDetails) {
    const eventDetails = getEventDetails(initialEventDetails);
    const modifiedEventDetails = safeMutate(eventDetails, draftEventDetails => {
      draftEventDetails.payload.source = chrEventConstants.eventLabel.VIEWED_IN_CHART;
    });
    return modifiedEventDetails;
  };

  const legendOrSeriesClickHandler = (seriesData) => {
    if(seriesData.url) {
      window.open(seriesData.url);
      eventTracker(seriesData.eventDetails?.eventName, seriesData.eventDetails?.payload);
    }
  }

  const seriesData = seriesMetrics.map((metric) => {
    return {
      name: metric.name,
      tooltip: metric.tooltip,
      color: metricColorMap[metric.uId],
      y: metric.data.value,
      previousPeriod: metric.data.previousPeriod,
      alert: metric.data.alert,
      url: metric.url,
      eventDetails: getAdditionalEventDetails(metric.eventDetails),
      roleBasedSplit: metric.data.role_based_split,
      translationMap: metric.translationMap,
      events: {
        click: function (_event) {
          legendOrSeriesClickHandler(this);
        },
        legendItemClick: function (event) {
          event.preventDefault();
          legendOrSeriesClickHandler(this);
        }
      }
    };
  });

  return {
    chart: {
      height: 280,
      events: {
        load: function () {
          if (this.options.chart.forExport) {
            this.legend.update({
              labelFormatter: function () {
                return renderToString(<ChartLegend basic={ true } name={ this.name } tooltip={ this.tooltip } value={ this.y } />);
              }
            });
            this.subtitle.update({
              text: renderToString(<ChartSubtitle basic={true} name={subTitleMetic.name} value={subTitleMetic.data.value} />),
              x: -70
            });
            this.redraw();
          }
        },
        render: function () {
          jQuery('.popover').remove();
          jQuery(".cjs-manual-react-popover").popover();
        }
      }
    },
    legend: {
      useHTML: true,
      symbolPadding: 10,
      labelFormatter: function () {
        return renderToString(<ChartLegend name={ this.name } tooltip={ this.tooltip } value={ this.y } renderedAsString previousPeriod={ this.previousPeriod } alert={ this.alert } />);
      }
    },
    subtitle: {
      text: renderToString(<ChartSubtitle name={ subTitleMetic.name } value={ subTitleMetic.data.value } renderedAsString previousPeriod={ subTitleMetic.data.previousPeriod } />),
      useHTML: true,
      verticalAlign: 'middle',
      x: -110,
      y: 10,
    },
    tooltip: {
      useHTML: true,
      padding: 1,
      headerFormat: "",
      pointFormatter: function () {
        return renderToString(<ChartTooltip { ...this } />);
      },
    },
    exporting: {
      filename: getExportFileName(exportFileName)
    },
    series: [
      {
        data: seriesData,
        name: exportFileName,
        size: '100%',
        innerSize: '50%',
        showInLegend: true,
        dataLabels: {
          enabled: false
        },
        cursor: "pointer"
      }
    ]
  };
};

export default getChartConfig;
